import React from "react"
import { Flex, FlexProps } from "@indeed/ifl-components"

export interface ResponsiveButtonGroupProps {
    children: React.ReactNode
    sx?: FlexProps["sx"]
}

export const ResponsiveButtonGroup: React.FC<ResponsiveButtonGroupProps> = ({ children, sx = {} }) => (
    <Flex
        sx={{
            flexDirection: ["column", "row-reverse"],
            inlineSize: "100%",
            gap: 2,
            ...sx,
        }}
    >
        {children}
    </Flex>
)
